import { render } from "./health.vue?vue&type=template&id=1300049c&scoped=true&ts=true"
import script from "./health.vue?vue&type=script&lang=ts"
export * from "./health.vue?vue&type=script&lang=ts"

import "./health.vue?vue&type=style&index=0&id=1300049c&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/mobile-mpe-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1300049c"]])

export default __exports__